import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { RestrictionCheck } from '@procureai/permissions-ui';
import { Fragment, ReactNode, useMemo } from 'react';
import { Union } from 'ts-toolbelt';

import { DataGridLinkProps } from '../../components/DataGridLink/DataGridLink';
import { NULLISH_CELL_VALUE } from '../../DataGridCustom.types';
import { LinkCell } from '../LinkCell/LinkCell';
import { NBSP } from '~/common/constants';
import { RouteId } from '~/routes/RouteId';

export type SupplierLinkCellValue = Union.Nullable<{
  label: ReactNode;
  id?: string; // DataGridLinkProps['to'];
  variant?: DataGridLinkProps['variant'];
}>;

interface SupplierLinkCellProps<R extends GridValidRowModel = any> {
  value: SupplierLinkCellValue | SupplierLinkCellValue[];
  row: R;
  needs?: RestrictionCheck;
}

export const SupplierLinkCell = <R extends GridValidRowModel = any>({ ...props }: SupplierLinkCellProps<R>) => {
  const { value: valueProp } = props;
  const values: SupplierLinkCellProps<R>['value'] = useMemo(() => {
    if (valueProp) {
      return Array.isArray(valueProp) ? valueProp : [valueProp];
    }
    return null;
  }, [valueProp]);

  if (values) {
    const result = values
      .map((value, index) => {
        if (value) {
          return (
            <Fragment key={index}>
              {index > 0 ? `,${NBSP}` : null}
              {value.id ? (
                <LinkCell
                  {...props}
                  value={{
                    label: value.label,
                    to: RouteId.supplierDetail(value.id),
                    variant: value.variant,
                  }}
                  needs={props.needs}
                />
              ) : (
                value.label
              )}
            </Fragment>
          );
        }
        return null;
      })
      .filter(Boolean);

    return result.length ? <>{result}</> : null;
  }
  return <>{NULLISH_CELL_VALUE}</>;
};
